/**
 * Size bucket → Tailwind class mapping for sponsor logo display.
 * Replaces the old SPONSOR_DISPLAY_SIZES (which was keyed by gold/silver/bronze).
 * Now keyed by size bucket (large/medium/small) from map_sponsor_tiers.
 */
import type { SizeBucket } from "@wondermaps/db";

export const SIZE_BUCKET_CLASSES: Record<string, Record<SizeBucket, string>> = {
  splash: {
    large: "max-h-10 max-w-28",
    medium: "max-h-7 max-w-20",
    small: "max-h-5 max-w-16",
  },
  welcome: {
    large: "max-h-8 max-w-24",
    medium: "max-h-6 max-w-16",
    small: "max-h-4 max-w-12",
  },
  menu: {
    large: "max-h-8 max-w-32",
    medium: "max-h-6 max-w-20",
    small: "max-h-5 max-w-16",
  },
};

/** Grid columns for sponsor tier groups based on size bucket */
export const SIZE_BUCKET_GRID_COLS: Record<SizeBucket, string> = {
  large: "space-y-1", // full width, stacked
  medium: "grid grid-cols-2 gap-1",
  small: "grid grid-cols-3 gap-1",
};
